<template>
    <l-control position="topright">
        <b-button @click="$emit('input', value + 1)" 
            class="shadow-lg" 
            variant="dark" 
            style="border-bottom-right-radius:0; border-bottom-left-radius:0;"
        >
            <img src="../assets/interface/zoom-in.svg" 
                class="mx-n1" 
                style="height:1.5em;filter:invert(90%)" 
            />
        </b-button><br>
        <b-button @click="$emit('input', value - 1)" 
            class="shadow-lg" 
            variant="dark" 
            style="border-top-left-radius:0; border-top-right-radius:0;"
        >
            <img src="../assets/interface/zoom-out.svg" 
                class="mx-n1" 
                style="height:1.5em;filter:invert(90%)" 
            />
        </b-button>
    </l-control>
</template>

<script>
import { LControl } from 'vue2-leaflet'
export default {
    name: "UebersichtControlZoom",
    components: {
        LControl
    },
    props:{
        value: Number
    }
}
</script>